// frontend/src/services/ProductService.js
import axiosInstance from '../helpers/axiosConfig';
import axiosInstanceMultipart from '../helpers/axiosConfigMultipart';

class ProductService {
  static getAds = (fullPath, config = {}) => axiosInstance.get(fullPath, config);
  static getSingleAd = (id) => axiosInstance.get(`/products/${id}`);
  static getUserAds = async (userId, params = '', config = {}) => axiosInstance.get(`/products/user/${userId}?${params}`, config);
  static getHomePageAds = () => axiosInstance.get(`/products/home-ads`);
  static deleteAd = (id) => axiosInstance.delete(`/products/delete/${id}`);
  static updateAd = (id, formData) => axiosInstanceMultipart.put(`/products/update/${id}`, formData);
  static changeAdStatus = (id) => axiosInstance.put(`/products/changeAdStatus/${id}`);
  static viewAds = (id) => axiosInstance.put(`/products/${id}`);
  static phoneViews = (id) => axiosInstance.put(`/products/${id}/phoneViews`);
  static createAd = (body) => axiosInstanceMultipart.post(`/products/create`, body);
  static exportAds = (body) => axiosInstance.post('/products/export-ads', body);

  static rateAd = (id, body) => axiosInstance.post(`/products/adsRating/${id}`, body);

  static getSubCategories = (id) => axiosInstance.get(`/categories/subCategories/${id}`);
  static getSubCategoriesFields = (id) => axiosInstance.get(`/categories/subCategoryFields/${id}`);

  static getAllCategories = () => axiosInstance.get('/categories');
  static getCities = (category, subcategory, extraFilters = {}) => {
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    if (subcategory) params.set('subCategory', subcategory);
    if (extraFilters.search) params.set('search', extraFilters.search);
    if (extraFilters.priceFrom) params.set('priceFrom', String(extraFilters.priceFrom));
    if (extraFilters.priceUpTo) params.set('priceUpTo', String(extraFilters.priceUpTo));
    if (extraFilters.askForPrice) params.set('askForPrice', '1');
    if (extraFilters.fields && extraFilters.fields.length > 0) params.set('fields', JSON.stringify(extraFilters.fields));
    const query = params.toString();
    return axiosInstance.get(`/dropdown/city${query ? '?' + query : ''}`);
  };

  static getUserSavedAds = (page, pageSize) => axiosInstance.get(`/products/getAll/wishlist?page=${page}&pageSize=${pageSize}`);
  static getAdsArrayInfo = (data) => axiosInstance.post('/products/getAdsArrayInfo', data);
  static updateWishList = (id) => axiosInstance.post(`/products/wishlist/${id}`);
  static deleteWishList = (id) => axiosInstance.delete(`/products/wishlist/${id}`);

  static getContract = (type) => axiosInstance.get(`/products/contract?type=${type}`);

  static getSuggestions = (search, category, config = {}) => {
    const params = new URLSearchParams({ search });
    if (category) params.set('category', category);
    return axiosInstance.get(`/products/suggestions?${params.toString()}`, config);
  };

  static getAllSliders = () => axiosInstance.get('/sliders/all');

  // Comments
  static getComments = (adId, page = 1, limit = 10) => axiosInstance.get('/comments', { params: { adId, page, limit } });
  static addComment = (body) => axiosInstance.post('/comments', body);
  static editComment = (commentId, body) => axiosInstance.put(`/comments/${commentId}`, body);
  static deleteComment = (commentId) => axiosInstance.delete(`/comments/${commentId}`);
}

export default ProductService;
